import { useEffect } from 'react';
import { useSocket } from '../../context/SocketContext';
import { toast } from 'react-hot-toast';

const NotificationListener = () => {
    const socket = useSocket();

    useEffect(() => {
        if (!socket) return;

        const handleNotification = (data) => {
            // Play sound if possible
            try {
                // Ensure the path is correct or allow browser default beep if custom sound fails
                // For now just toast
            } catch (e) { }

            toast(data.message, {
                icon: '🔔',
                duration: 5000,
                style: {
                    border: '1px solid #fcd535',
                    padding: '16px',
                    color: '#333',
                    background: '#fff3cd'
                },
            });
        };

        socket.on('admin_notification', handleNotification);

        return () => {
            socket.off('admin_notification', handleNotification);
        };
    }, [socket]);

    return null;
};

export default NotificationListener;
